import actionTypes from './actionTypes';
import ValueSource from '../../sources/value';
import { addNotification } from './notification';
import { getRecentValueReferenceIds } from '../../components/elementSelector/selectors/picker/valuePickerUtils';

export const MAX_RECENT_ITEMS_COUNT = 8;

export const setRecentValues = payload => ({
    type: actionTypes.SET_RECENT_VALUES,
    payload,
});

/**
 * Get a list of recently used Values
 *
 * @param {*} authenticationToken authentication token
 * @param {*} tenantId tenant Id
 * @param {*} filters value picker filters
 * @param {*} maxRecentItems limit size of returned items
 * @returns A list of Values in most recently used order
 */
export const getRecentValues = (authenticationToken, tenantId, filters, maxRecentItems = MAX_RECENT_ITEMS_COUNT) => async (dispatch) => {

    const limit = maxRecentItems < 1 ? MAX_RECENT_ITEMS_COUNT : maxRecentItems;
    const recentValueReferenceIds = getRecentValueReferenceIds();
    if (!recentValueReferenceIds || recentValueReferenceIds.length === 0) {
        dispatch(setRecentValues([]));
        return;
    }

    try {
        // Get all the unique Value References for ids that are saved in our recent Values list. Note that we have to
        // fetch because some recently used ids may have been deleted, or be for a different tenant.
        // Also ignore any limit filter because getList() returns an row for each property in a value object.
        const valueFilters = { ...filters, limit: 0, id: [...new Set(recentValueReferenceIds.map(rvrid => rvrid.valueId))] };
        const values = await ValueSource.getList(authenticationToken, tenantId, valueFilters);

        // Build our recent value list preserving the order of the saved recent Value Ids.
        const recentValueList = [];
        recentValueReferenceIds.forEach((rvri) => {
            const v = values.find(value => value.id === rvri.valueId && value.typeElementPropertyId === rvri.propertyId);
            if (v) {
                recentValueList.push(v);
            }
        });

        dispatch(setRecentValues(recentValueList.slice(0, limit)));
    } catch ({ message }) {
        dispatch(addNotification({
            type: 'error',
            message,
            isPersistent: true,
        }));
        dispatch(setRecentValues([]));
    }
};
